"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var time_zones_1 = require("../constants/time-zones");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var storage_service_1 = require("../modules/storage/storage.service");
var LocaleTimePipe = /** @class */ (function (_super) {
    __extends(LocaleTimePipe, _super);
    function LocaleTimePipe(storageService) {
        var _this = _super.call(this, 'en-US') || this;
        _this.storageService = storageService;
        return _this;
    }
    LocaleTimePipe.prototype.transform = function (date, args) {
        var timeZoneId = this.storageService.getItem('timezoneId') || time_zones_1.TimeZones.pacificStandardTime.id;
        var utcOffsetString;
        // If `date` is a Date, it has already been converted to local time
        // If `date` is a string, a trailing Z indicates a UTC timestamp
        var isUTCFormat = !(date instanceof Date) && date.toString().endsWith('Z');
        if (isUTCFormat) {
            var timeZone = time_zones_1.TimeZonesById.get(timeZoneId);
            if (timeZone) {
                // moment-timezone does the hard work of deciding whether DST was
                // in effect at the given DateTime.
                var isDSTAtGivenTime = moment_timezone_1.default(date).tz(timeZone.tzdbName).isDST();
                if (isDSTAtGivenTime) {
                    utcOffsetString = timeZone.daylight;
                }
                else {
                    utcOffsetString = timeZone.standard;
                }
            }
        }
        var cultureName = this.storageService.getItem('cultureName') || 'en-us';
        switch (cultureName.toLowerCase()) {
            case 'en-gb':
                return _super.prototype.transform.call(this, date, 'hh:mm a', utcOffsetString);
            case 'en-ca':
                return _super.prototype.transform.call(this, date, 'h:mm a', utcOffsetString);
            case 'fr-ca':
                return _super.prototype.transform.call(this, date, 'hh:mm a', utcOffsetString);
            case 'fr-fr':
                return _super.prototype.transform.call(this, date, 'H:mm', utcOffsetString);
            case 'en-us':
            default:
                return _super.prototype.transform.call(this, date, 'h:mm a', utcOffsetString);
        }
    };
    return LocaleTimePipe;
}(common_1.DatePipe));
exports.LocaleTimePipe = LocaleTimePipe;
